import { type TranslationTree } from '@/i18n/types';

export const messages = {
  error: 'Não foi possível ativar a conta, tente novamente',
} satisfies TranslationTree;
